export default {
  inserted: el => {
    function loadImage() {
      for (const CHILD of el.children) {
        if (CHILD.nodeName === "SOURCE") {
          if (CHILD.type === "image/webp") {
            CHILD.srcset = `${CHILD.dataset.srcset}.webp`
          } else if (CHILD.type === "image/jpeg") {
            CHILD.srcset = `${CHILD.dataset.srcset}`
          } else if (CHILD.type === "image/png") {
            CHILD.srcset = `${CHILD.dataset.srcset}`
          }
        } else if (CHILD.nodeName === "IMG") {
          CHILD.src = CHILD.dataset.url
        }
      }
    }
    function handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      const options = {
        root: null,
        threshold: "0"
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }
    if (window["IntersectionObserver"]) {
      createObserver();
    } else {
      loadImage();
    }
  }
};
